import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import { ReOrg, GetPriorities, GetOrg } from '../../../../api'
import { PRIORITIES } from '../../../../constants/Consult'

export default function TransferDialog({dialogState, user}) {

    const [orgs, setOrgs] = useState();
    const [org, setOrg] = useState();
    const [priorities, setPriorities] = useState([]);
    const [customPriorities, setCustomPriorities] = useState(null);
    const [priority, setPriority] = useState('');
    const [prioritiesLoading, setPrioritiesLoading] = useState(false);

    useEffect(() => {
        const consultOrgs = user.access && user.access.filter(e => e.consult || e.transfer)
        setOrgs(consultOrgs)

    }, [user.access, dialogState.orgId]);

    useEffect(() => {
        if (dialogState.orgId) setOrg(dialogState.orgId)
    }, [dialogState])

    useEffect(() => {
        if (org) {
            setPriority('')
            setPrioritiesLoading(true)
            Promise.all([
                GetOrg(org).then(resp => setPriorities(resp.priorities || [])),
                GetPriorities(org).then(cp => setCustomPriorities(cp?.length ? cp : null)).catch(() => setCustomPriorities(null))
            ]).finally(() => setPrioritiesLoading(false))
        }
    }, [org])

    const onSend = () => {
        const isRefPriority = customPriorities && typeof priority === 'string' && priority.length === 24
        const data = { org, priority: isRefPriority ? null : (priority || null), priorityRef: isRefPriority ? priority : null }
        ReOrg(dialogState.studyId, data).then(() => dialogState.onTransferComplete && dialogState.onTransferComplete(dialogState, org)).catch(e=>e)
        dialogState.onSend && dialogState.onSend(dialogState, org)
    }

    return (
        <Dialog open={dialogState.open || false} onClose={dialogState.onClose} fullWidth maxWidth="xs">
            <DialogTitle>Transfer Study</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{mb:2}} color="secondary">Billing codes will be lost in the transfer</DialogContentText>
                {orgs && (
                    <FormControl sx={{mb: 1}} fullWidth variant="standard">
                        <TextField
                        id="org"
                        value={org || ''}
                        label="Organization"
                        onChange={e => setOrg(e.target.value)}
                        variant="standard"
                        select
                        required
                        >
                        {orgs.map((e) => (
                            <MenuItem key={e.org.id} value={e.org.id}>
                            {e.org.name}
                            </MenuItem>
                        ))}
                        </TextField>
                    </FormControl>
                )}
                {(customPriorities || !!priorities.length) && (
                    <FormControl sx={{mb: 1}} fullWidth variant="standard">
                        <TextField
                        id="priority"
                        value={priority === null || priority === undefined ? '' : priority}
                        label="Priority"
                        onChange={e => setPriority(e.target.value)}
                        variant="standard"
                        select
                        required
                        >
                        {customPriorities ? (
                            [<MenuItem key="" value=""></MenuItem>,
                            ...customPriorities.sort((a, b) => a.sortOrder - b.sortOrder).map(p => (
                                <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>
                            ))]
                        ) : (
                            PRIORITIES.filter(e => !e.id || priorities.includes(e.id)).map(e => !e.hidden &&
                                <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>
                            )
                        )}
                        </TextField>
                    </FormControl>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={dialogState.onClose}>Cancel</Button>
                <Button onClick={onSend} disabled={prioritiesLoading || ((customPriorities || !!priorities.length) && !priority && priority !== 0)}>Transfer</Button>
            </DialogActions>
        </Dialog>
    );
}